import { Contrato } from "./contrato";
import { CopiaContrato } from "./copiaContrato";

export class EnderecoContrato {
    nuTransacao: string;
    nuProtocolo: string;
    cdRetorno: string;
    cdMsgemRetorno: string;
    dsMsgemRetorno: string;
    dsMsgemMainframeRetorno: string;
    nuControle: string;
    nuDocumento: string;
    cdCtrlProcessamento: string;
    textoAutenticacao: string;
    cdIndcdTransacao: string;
    lstMensagem: string[];
    nmCliente: string;
    cdTipoCpfCnpj: string;
    nuCpfCnpj: string;
    nuCpfCnpjFormatado: string;
    contrato: Contrato;
    listaContrato: Contrato[];
    copiaContrato: CopiaContrato;
    listaCopiaContrato: CopiaContrato[];
    indcdContratoCdc: boolean;
    indcdContratoLeasing: boolean;
    cdIndOperacao: string;

    constructor() { }
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/enderecoContrato.ts